import { render, staticRenderFns } from "./CommentTemplates.vue?vue&type=template&id=69081f3e&"
import script from "./CommentTemplates.vue?vue&type=script&lang=js&"
export * from "./CommentTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69081f3e')) {
      api.createRecord('69081f3e', component.options)
    } else {
      api.reload('69081f3e', component.options)
    }
    module.hot.accept("./CommentTemplates.vue?vue&type=template&id=69081f3e&", function () {
      api.rerender('69081f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CommentTemplates.vue"
export default component.exports